import PropTypes from 'prop-types'
import React from 'react'
import { skin } from 'Utils'
import { PAGE_CONTEXT as p } from 'Constants'
import { CardLoadingGrid } from 'Blocks'
import skins from '../skins'
import mainSkins from '../../../skins'

const Loading = props => {
  return (
    <div className={`main-container ${props.className}`}>
      <div className="heading">
        <div />
      </div>
      <div className="panel-trigger">
        <div />
      </div>
      <div className="product-list-wrapper">
        <CardLoadingGrid pageName={p.PRODUCT_LIST} />
      </div>
    </div>
  )
}

Loading.propTypes = {
  className: PropTypes.string
}

export default skin(Loading, mainSkins, skins)
